import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id B53C0CF7-F923-409F-91C3-420513E44231
 * name chart-line-stacked
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-line-stacked.svg
 * tags
 * - Math 
 */
export const ChartLineStackedIcon = createSvgIcon(<><path d="M17.45,15.18L22,6.81V19L22,21H2V3H4V15.54L4,19H4.31L6,19H6.57L10.96,11.44L17.45,15.18M22,3L21.97,3.45L17,11L10,6L6,12V3H22Z" /></>, 'ChartLineStackedIcon');
export default ChartLineStackedIcon